import { Either } from 'monet';
import LeftResponse from '@/storage/LeftResponse';

/**
 * @description Запрос на заказ консультации.
 * @param {string} fullName ФИО.
 * @param {string} phone    Телефон.
 * @constructor
 */
export function OrderConsultationRequest(fullName, phone) {
  this.toQuery = () => ({
    full_name: fullName,
    phone,
  });
}

/**
 * @description Шлюз тарифов.
 * @param {Axios} axios
 */
export default function TariffGateway(axios) {
  /**
   * @description Заказать консультацию.
   * @param {OrderConsultationRequest} request
   * @returns {Promise<Either>}
   */
  this.orderConsultation = (request) => axios
    .post('/api/tariff/consultation-orders', request.toQuery())
    .then(
      async (response) => Either.right(response.data.message),
      async (error) => {
        if (error.isAxiosError && [400].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.left(leftResponse);
        }
        throw error;
      },
    );
  /**
   * @description Получить данные по тарифу клиники
   * @returns {Promise<Either>}
   */
  this.getTariffInfo = () => axios
    .get('/api/tariff/info')
    .then(
      (response) => {
        const { tariffInfo } = response.data;
        return Either.Right(tariffInfo);
      },
      (error) => {
        if (error.isAxiosError && [400].includes(error.response.status)) {
          const { causes, title } = error.response.data;
          const leftResponse = new LeftResponse(causes, title);
          return Either.Left(leftResponse);
        }
        throw error;
      },
    );
}
